import * as images from "@/components/images/Images";
import { AboutUsExcellenceData } from "./types";

export const aboutUsExcellenceData: AboutUsExcellenceData = {
  title: "Our beliefs and values",
  card: {
    title: "Excellence",
    description:
      "We believe in never settling for less and are committed to setting the benchmark for excellence across all business areas. This means we’re the best where it matters most: high-quality outcomes and exceptional experience.",
    imageUrl: images.aboutUsExcellence,
  },
  items: [
    {
      description:
        "We consistently deliver best-in-market accuracy. Our network of native-language translators is rigorously qualified and vetted, rated and ranked, and offers technical use case and industry specializations our clients deserve. We perform a rigorous quality review process to ensure we capture the nuances and cultural context the way AI can’t.",
    },
    {
      iconId: "icon-people_64",
      title: "Exceptional experience",
    },
    {
        iconId: "icon-business_64",
      title: "Continuous improvement",
    },
  ],
} as const;
